import { Component } from '@angular/core';
declare var $: any;
import { ApiService } from './api.service';
import { Router } from '@angular/router';
import { Cache } from './cache';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  show = false;
  show2 = true;
  title = 'nogalClient';
  name: any;
  control: any;
  controlA: any;
  activeU: any;
  activeR: any;
  activeS: any;
  activeI: any;
  activeC: any;
  activeP: any;
  activeCu: any;
  activeCR: any;
  activeH: any;
  activeO: any;
  activeCE: any;
  activeCV: any;
  activeSE: any;
  activeSEB: any;
  activeCuO: any;
  activeCuOStore: any;
  activeHRE: any;
  activeHReport: any;
  activeCVV: any;
  activeCVEm: any;
  allCaAnsRFNot: any = [];
  allCaAnsNot: any = [];
  activeCVEmAttendances: any;
  activeCVEmAttendancesSalary: any;
  activeCVEmPermession: any;
  activeHReportAccounts: any;
  activeHReportCashPayments: any;
  activeHReportPrivate: any;
  activeHReportPrivatePaymentsReport: any;
  lenghtItem: any;
  showI0: any = false;

  Users: any = false;
  Permession: any = false;
  Employees: any = false;
  Attendances: any = false;
  Salary: any = false;
  Branches: any = false;
  Suppliers: any = false;
  Category: any = false;
  Items: any = false;
  Sellers: any = false;
  Brokers: any = false;
  Customer: any = false;
  Visit: any = false;
  Offer: any = false;
  Quotations: any = false;
  Orders: any = false;
  Store: any = false;
  Request: any = false;
  Returns: any = false;
  Reports: any = false;
  ReportsPrivate: any = false;
  PaymentsReport: any = false;
  Histoty: any = false;
  CashPayments: any = false;
  AccountsGuide: any = false;
  CashReceipts: any = false;
  activeCashReceipts: any;
  activeDailyRestrictions: any;
  DailyRestrictions: any = false;
  GeneralReports: any = false;
  activeGeneralReports: any;
  sumSales: any;
  showI1: any = false;
  constructor(private _ApiService: ApiService, private _Router: Router) {
    this._ApiService.getControls().subscribe((res)=>{
      this.controlA = res;
    })
    this._ApiService.Profile().subscribe((res)=>{
      if(res.check === true) {
        this.show2 = false;
        this.show = true;
        this.name = res.name;
        /// dashboard menu item
        res.data.forEach((element: any) => {
          if(element.checked === 1) {
            if(element.name === 'Users') {
              this.Users = true
            } else if(element.name === 'GeneralReports') {
              this.GeneralReports = true
            } else if(element.name === 'PrivateReport') {
              this.ReportsPrivate = true
            } else if(element.name === 'PaymentsReport') {
              this.PaymentsReport = true
            } else if(element.name === 'DailyRestrictions') {
              this.DailyRestrictions = true
            } else if(element.name === 'CashReceipts') {
              this.CashReceipts = true
            } else if(element.name === 'Items') {
                this.Items = true
             }else if(element.name === 'Permession') {
              this.Permession = true
            } else if(element.name === 'Employees') {
              this.Employees = true
            } else if(element.name === 'Attendances') {
              this.Attendances = true
            } else if(element.name === 'Salary') {
              this.Salary = true
            } else if(element.name === 'Branches') {
              this.Branches = true
            } else if(element.name === 'Suppliers') {
              this.Suppliers = true
            } else if(element.name === 'Category') {
              this.Category = true
            } else if(element.name === 'Sellers') {
              this.Sellers = true
            } else if(element.name === 'Brokers') {
              this.Brokers = true
            } else if(element.name === 'Customer') {
              this.Customer = true
            } else if(element.name === 'Visit') {
              this.Visit = true
            } else if(element.name === 'Offer') {
              this.Offer = true
            } else if(element.name === 'Quotations') {
              this.Quotations = true
            } else if(element.name === 'Orders') {
              this.Orders = true
            } else if(element.name === 'Store') {
              this.Store = true
            } else if(element.name === 'Request') {
              this.Request = true
            } else if(element.name === 'Returns') {
              this.Returns = true
            } else if(element.name === 'Reports') {
              this.Reports = true
            } else if(element.name === 'Histoty') {
              this.Histoty = true
            } else if(element.name === 'CashPayments') {
              this.CashPayments = true
            } else if(element.name === 'AccountsGuide') {
              this.AccountsGuide = true
            }
          }
        });
        for(var x = 0 ; x<this.controlA.length ; x++){
          if(res.control == this.controlA[x].id){
            this.control = this.controlA[x].name;
          }
        }
        this._ApiService.allRequestRFAns00().subscribe((res)=>{
          this.allCaAnsRFNot = [];
          res.forEach((element: any) => {
            if (element.replay == 0) {
              this.allCaAnsRFNot.push(' ');
            }
          });
        })
        this._ApiService.allRequestRFAns().subscribe((res)=>{
          this.allCaAnsNot = [];
          res.forEach((element: any) => {
            if (element.replay == 0) {
              this.allCaAnsNot.push(' ');
            }
          });
        })
      } else {
        this.show2 = true;
        this.show = false;
      }
    })
   }
   refreshNotification() {
    this._ApiService.allRequestRFAns00().subscribe((res)=>{
      this.allCaAnsRFNot = [];
      res.forEach((element: any) => {
        if (element.replay == 0) {
          this.allCaAnsRFNot.push(' ');
        }
      });
    })
    this._ApiService.allRequestRFAns().subscribe((res)=>{
      this.allCaAnsNot = [];
      res.forEach((element: any) => {
        if (element.replay == 0) {
          this.allCaAnsNot.push(' ');
        }
      });
    })
   }
   goout(){
    $('.loading').css({display: 'block'});
    this._ApiService.goout().subscribe(()=>{
      localStorage.removeItem('permission');
      this.show2 = true;
      this.show = false;
      Cache.remove('login');
      this._Router.navigate(['']);
      Cache.remove('login');
      $('.loading').css({display: 'none'});
    })
  }
   goProfile(){
    this._ApiService.getControls().subscribe((res)=>{
      this.controlA = res;
    })
    this._ApiService.Profile().subscribe((res)=>{
      if(res.check === true) {
        this.show2 = false;
        this.show = true;
        this.name = res.name;
        for(var x = 0 ; x<this.controlA.length ; x++){
          if(res.control == this.controlA[x].id){
            this.control = this.controlA[x].name;
          }
        }
      } else {
        this.show2 = true;
        this.show = false;
      }
    })
   }
   showI(){
    if(this.activeI === 'active') {
      this.showI0 = true;
    } else {
      this.showI0 = false;
    }
    if(this.activeHReport === 'active') {
      this.showI1 = true;
    } else {
      this.showI1 = false;
    }
   }
  togle() {
    // ------------------------------------------------------- //
    // Side Navbar Functionality
    // ------------------------------------------------------ //
      if ($(window).outerWidth() > 1194) {
          $('nav.side-navbar').toggleClass('shrink');
          $('.page').toggleClass('active');
      } else {
          $('nav.side-navbar').toggleClass('show-sm');
          $('.page').toggleClass('active-sm');
      }
}
}
